(() => {
  let timer;
  const cache = new Map();

  async function replaceDescription() {
    const titleEl = document.querySelector('.byob-quickview-title');
    const descEl = document.querySelector('.byob-quickview-desc');

    if (!titleEl || !descEl) return;

    const title = titleEl.textContent.replace(/\s+/g, ' ').trim();
    if (!title) return;

    try {
      let description = cache.get(title);

      if (!description) {
        const root = window.Shopify?.routes?.root || '/';

        const searchUrl =
          `${root}search/suggest.json` +
          `?q=${encodeURIComponent(title)}` +
          `&resources[type]=product` +
          `&resources[limit]=1`;

        const searchData = await fetch(searchUrl).then(response =>
          response.json()
        );

        const product =
          searchData?.resources?.results?.products?.[0];

        if (!product?.url) return;

        const separator = product.url.includes('?') ? '&' : '?';

        const sectionHtml = await fetch(
          `${product.url}${separator}section_id=byob-fragrance-description`
        ).then(response => response.text());

        const documentHtml = new DOMParser().parseFromString(
          sectionHtml,
          'text/html'
        );

        description = documentHtml
          .querySelector('.byob-fragrance-metafield')
          ?.textContent
          ?.trim();

        if (!description) return;

        cache.set(title, description);
      }

      if (descEl.textContent.trim() !== description) {
        descEl.textContent = description;
      }
    } catch (error) {
      console.error('[BYOB FFD]', error);
    }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(replaceDescription, 100);
  }

  new MutationObserver(scheduleUpdate).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  scheduleUpdate();
})();